import { useEffect } from "react";
import useModal from "./useModal";
import BookBetModalComponent from "../components/BookBetModal";
import LiveAuthorizationModal from "../components/LiveAuthorizationModal";
import ConfirmBetChangesModal from "../components/ConfirmBetChangesModal";
import BetDeclinedModal from "../components/BetDeclinedModal";
import { PlaceBetStatus } from "../types/enums";

export const useSummaryModals = (authState: AuthorizationState) => {
  const [BookBetModal, toggleBookBetModal] = useModal(BookBetModalComponent);
  const [AuthModal, toggleAuthModal, isAuthModalOpen] = useModal(
    LiveAuthorizationModal,
  );
  const [ConfirmModal, toggleConfirmModal, isConfirmModalOpen] = useModal(
    ConfirmBetChangesModal,
  );
  const [DeclinedModal, toggleDeclinedModal, isDeclinedModalOpen] =
    useModal(BetDeclinedModal);

  useEffect(() => {
    switch (authState.status) {
      case PlaceBetStatus.Authorizing:
        if (!isAuthModalOpen) toggleAuthModal();
        break;
      case PlaceBetStatus.ConfirmChanges:
        if (isAuthModalOpen) toggleAuthModal();
        if (!isConfirmModalOpen) toggleConfirmModal();
        break;
      case PlaceBetStatus.Declined:
        if (isAuthModalOpen) toggleAuthModal();
        if (!isDeclinedModalOpen) toggleDeclinedModal();
        break;
      case PlaceBetStatus.Idle:
      case PlaceBetStatus.Placing:
        if (isAuthModalOpen) toggleAuthModal();
        if (isConfirmModalOpen) toggleConfirmModal();
        if (isDeclinedModalOpen) toggleDeclinedModal();
        break;
    }
  }, [
    authState.status,
    isAuthModalOpen,
    isConfirmModalOpen,
    isDeclinedModalOpen,
    toggleAuthModal,
    toggleConfirmModal,
    toggleDeclinedModal,
  ]);

  return {
    BookBetModal,
    toggleBookBetModal,
    AuthModal,
    ConfirmModal,
    DeclinedModal,
    toggleDeclinedModal,
  };
};
